module.exports = "/static/media/wait_time_icon.e710c631.svg";